import { render } from "./CennikView.vue?vue&type=template&id=15c0bdb2"
import script from "./CennikView.vue?vue&type=script&lang=js"
export * from "./CennikView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__